<template>
  <section>
    <!-- <div -->
      <!-- v-for="(activity, indexA) in activities" -->
      <!-- :key="activity._id.$oid"> -->
      <!-- color="grey lighten-4" flat -->

      <!-- <div v-if="indexA == active"> -->
        <div
          id="activity"
          class="container section-title">
          <h2
            :style="{color: $store.getters.clientStyle.secondary}"
            class="is-size-3 has-text-weight-bold category-title">{{ activeActivity.name }}</h2>
          <div class="columns is-centered">
            <div class="column is-four-fifths has-text-darker">
              <p>{{ activeActivity.description }}</p>
            </div>
          </div>
        </div>

<div :style="{borderColor: $store.getters.clientStyle.primary}"
  class="global-question-card container global-question-card-padding">
        <div
          v-for="(question, index) in sortByIndex(activeActivity.questions)"
          :key="question._id.$oid"
          :id="getQuestionId(index)"
          row >

          <div v-if="!question.disabled">

            <div v-if="question.name == 'Opdrachtgever'">
              <client-id
                :question-data="question"
                :number="getQuestionNumber(index)"/>

            </div>
            <div v-else>
              <property
                :question-data="question"
                :number="getQuestionNumber(index)"/>

            </div>

           </div>
          </div>
        </div>
      <!-- </div> -->
    <!-- </div> -->

  </section>
</template>

<script>
import _ from 'lodash'
import smoothscroll from 'smoothscroll-polyfill'

smoothscroll.polyfill()

import RadioQuestion from '../elements/RadioQuestion'
import ScaleQuestion from '../elements/ScaleQuestion'
import DropdownQuestion from '../elements/DropdownQuestion'
import CheckboxQuestion from '../elements/CheckboxQuestion'
import ValueQuestion from '../elements/ValueQuestion'
import TextQuestion from '../elements/TextQuestion'
import CalendarQuestion from '../elements/CalendarQuestion'
import Property from '../elements/Property'
import ClientID from '../elements/ClientID'

export default {
  name: 'Section',
  components: {
    'radio-question': RadioQuestion,
    'scale-question': ScaleQuestion,
    'dropdown-question': DropdownQuestion,
    'checkbox-question': CheckboxQuestion,
    'value-question': ValueQuestion,
    'text-question': TextQuestion,
    'calendar-question': CalendarQuestion,
    'property': Property,
    'client-id': ClientID
  },
  data () {
    return {
      activities: this.$store.getters.getActivities,
      active: this.$store.getters.getActiveActivity,
      focussedQuestion: 0,
      questionIds: [],
      config: {
        options: [{value:'a'},{value:'b'}],
        placeholder: 'Selecteer...',
        backgroundColor: '#f2f2f2',
        textColor: 'black',
        borderRadius: '5px',
        // border: '1px solid gray',
        width: 350
      }
      // form: this.$store.getters.getSurvey
    }
  },
  methods: {

  },
  props: {
    activityIndex : Number
  },
  created () {
    window.addEventListener('keydown', (e) => {
      e.stopPropagation()

      // console.log('NEW KEYBOARD EVENT ------------------------------------------------------------- ' + e.key)

      let smoothScrollSupport = 'scrollBehavior' in document.documentElement.style;

      if (e.key == 'ArrowDown') {
        e.preventDefault()

        let next = Number(this.focussedQuestion)+1
        let target = this.questionIds[next]
        let elem = document.getElementById(target)

        if (this.questionIds.includes(target) && elem && smoothScrollSupport) {
          this.focussedQuestion = next
          elem.scrollIntoView({behavior: 'smooth', block: 'center', inline: 'nearest'})

        } else {
          // console.log('TARGET DOES NOT EXIST!');

        }
      }

      if (e.key == 'ArrowUp') {
        e.preventDefault()

        let previous = Number(this.focussedQuestion) - 1
        let target = this.questionIds[previous]
        let elem = document.getElementById(target)

        if (this.questionIds.includes(target) && elem && smoothScrollSupport) {
          this.focussedQuestion = previous
          elem.scrollIntoView({behavior: 'smooth', block: 'center', inline: 'nearest'})

        } else {
          // console.log('TARGET DOES NOT EXIST!');

        }
      }
    });

    // window.addEventListener('scroll', _.debounce(function (e) {
    //   console.log(e);
    //   this.getIdInViewport();
    // }, 300, {leading:false, trailing:true}));
  },
  mounted () {
    setTimeout(() => {
      document.getElementById('activity').scrollIntoView({behavior: 'smooth', block: 'start', inline: 'nearest'})
    }, 400)

    for (var i = 0; i < this.activeActivity.questions.length; i++) {
      let questionId = 'question-' + this.active.toString() + '-' + i.toString()
      // console.log(questionId)
      this.questionIds.push(questionId)
    }

    window.addEventListener('scroll', _.debounce((e) => {
      let id = this.getIdInViewport()
      let index = id.substr(id.length - 1);
      // console.log('index: ' +index)
      this.focussedQuestion = index
      console.log('Focussed after scroll: ' + this.focussedQuestion);
    }, 300, {leading:false, trailing:true}));

  },
  methods: {
    getQuestionNumber (index) {
      var count = 0
      for (var i = 0; i < this.activities.length; i++) {
        if (i < this.active) {
          count += this.activities[i].questions.length
        }
      }
      count += (index + 1)
      return count
    },
    getQuestionId (index) {
      let questionId = 'question-' + this.active.toString() + '-' + index.toString()
      // console.log(questionId)
      return questionId
    },
    viewportPosition (id) {
      // console.log('check viewport position of ' + id);
      let result = 10000
      let elem = document.getElementById(id)
      if (elem) {
        let bounding = elem.getBoundingClientRect()
        result = bounding.top + bounding.bottom - (window.innerHeight || document.documentElement.clientHeight)
      }
      return result
    },
    getIdInViewport () {
      let positions = []
      let values = {}
      this.questionIds.forEach((id) => {
        let position = Math.abs(this.viewportPosition(id))
        // let key = Math.abs(position).toString()
        values[position] = id
        positions.push(position)
      })
      let min = Math.min.apply(null, positions)
      // console.log('question-id in viewport: ' + values[min])
      return values[min]
    },
    saveAnswer(a) {
      console.log(a);
      // this.$store.commit('updateActivity', this.$store.getters.getActivities)
      console.log(JSON.parse(localStorage.getItem('activities')));
    },
    sortByIndex(a) {
      return a.slice().sort((c, b) => c.index < b.index ? -1 : 1);
    },
    getConfig(values) {
      var config = {
          options:[],
          placeholder: 'Selecteer...',
          backgroundColor: '#f2f2f2',
          textColor: 'black',
          borderRadius: '5px',
          width: 350
      };
      values.forEach(function(value){config.options.push({value:value})});
      return config;
    }
  },
  computed: {
    activeActivity: function () {
      return this.$store.getters.getActivities[this.activityIndex]
    }
  }
}
</script>

<style scoped>

/* .section-background {
background-image: linear-gradient(white 20%, #f8f8f8);
} */

.section-title {
  margin-top: 30px;
  margin-bottom: 30px;
  padding-top: 80px;
  padding-bottom: 20px;
  text-align: center;
  padding-left: 40px;
  padding-right: 40px;
  max-width: 980px;
}

.category-title {
  margin-bottom: 20px;
}

/* .questions {
margin-top: 60px;
margin-bottom: 300px;
padding-left: 30px;
padding-right: 30px;
} */

.divider {
  border-width: 1px;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/Properties.vue